import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const alertVariants = cva(
  'dls-relative dls-w-full dls-rounded-lg dls-border dls-px-4 dls-py-3 dls-text-sm [&>svg+div]:dls-translate-y-[-3px] [&>svg]:dls-absolute [&>svg]:dls-left-4 [&>svg]:dls-top-4 [&>svg]:dls-text-foreground [&>svg~*]:dls-pl-7',
  {
    variants: {
      variant: {
        default: 'dls-bg-background dls-text-foreground',
        destructive:
          'dls-border-destructive/50 dls-text-destructive dark:dls-border-destructive [&>svg]:dls-text-destructive',
        success: 'dls-border-status-online/30 dls-bg-status-online/10 dls-text-status-online [&>svg]:dls-text-status-online',
        warning: 'dls-border-status-warning/30 dls-bg-status-warning/10 dls-text-status-warning [&>svg]:dls-text-status-warning',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

const Alert = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof alertVariants>
>(({ className, variant, ...props }, ref) => (
  <div ref={ref} role="alert" className={cn(alertVariants({ variant }), className)} {...props} />
));
Alert.displayName = 'Alert';

const AlertTitle = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, ref) => (
    <h5
      ref={ref}
      className={cn('dls-mb-1 dls-font-medium dls-leading-none dls-tracking-tight', className)}
      {...props}
    />
  )
);
AlertTitle.displayName = 'AlertTitle';

const AlertDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('dls-text-sm [&_p]:dls-leading-relaxed', className)} {...props} />
));
AlertDescription.displayName = 'AlertDescription';

export { Alert, AlertTitle, AlertDescription };
